module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__city",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "name",
      "id": "name",
      "label": "Название",
      "error": _vm.errors.first('name'),
      "required": true,
      "data-vv-name": "name",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.city.name),
      callback: function($$v) {
        _vm.$set(_vm.city, "name", $$v)
      },
      expression: "city.name"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "value",
      "id": "value",
      "label": "Полное наименование",
      "error": _vm.errors.first('value'),
      "required": true,
      "data-vv-name": "value",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.city.value),
      callback: function($$v) {
        _vm.$set(_vm.city, "value", $$v)
      },
      expression: "city.value"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "aoguid",
      "id": "aoguid",
      "label": "ФИАС",
      "data-vv-name": "aoguid",
      "data-vv-as": ' ',
      "error": _vm.errors.first('aoguid'),
      "required": true
    },
    model: {
      value: (_vm.city.aoguid),
      callback: function($$v) {
        _vm.$set(_vm.city, "aoguid", $$v)
      },
      expression: "city.aoguid"
    }
  }), _vm._v(" "), _c('z-input', {
    attrs: {
      "name": "parentguid",
      "id": "parentguid",
      "label": "ФИАС родителя",
      "data-vv-name": "parentguid",
      "data-vv-as": ' ',
      "error": _vm.errors.first('parentguid')
    },
    model: {
      value: (_vm.city.parentguid),
      callback: function($$v) {
        _vm.$set(_vm.city, "parentguid", $$v)
      },
      expression: "city.parentguid"
    }
  }), _vm._v(" "), _c('z-input', {
    attrs: {
      "name": "okato",
      "id": "okato",
      "label": "ОКАТО",
      "data-vv-name": "okato",
      "data-vv-as": ' ',
      "error": _vm.errors.first('okato')
    },
    model: {
      value: (_vm.city.okato),
      callback: function($$v) {
        _vm.$set(_vm.city, "okato", $$v)
      },
      expression: "city.okato"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3'),
      expression: "'min:3'"
    }],
    attrs: {
      "name": "regioncode",
      "id": "regioncode",
      "label": "Код региона",
      "data-vv-name": "regioncode",
      "data-vv-as": ' ',
      "error": _vm.errors.first('regioncode')
    },
    model: {
      value: (_vm.city.regioncode),
      callback: function($$v) {
        _vm.$set(_vm.city, "regioncode", $$v)
      },
      expression: "city.regioncode"
    }
  }), _vm._v(" "), _c('z-input-autocomplete', {
    attrs: {
      "name": "zone",
      "id": "zone",
      "display-property": "name",
      "property": "id",
      "return": "id",
      "label": "Направление",
      "callback": _vm.getZones,
      "default": _vm.city.zone && _vm.city.zone.name ? _vm.city.zone.name : ''
    },
    model: {
      value: (_vm.city.zone_id),
      callback: function($$v) {
        _vm.$set(_vm.city, "zone_id", $$v)
      },
      expression: "city.zone_id"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8194f062","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/City.vue
// module id = 1214
// module chunks = 0